import { ApiProvider } from '@/api';
import { App } from './views/App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HashRouter } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

const googleClientId = '582449076537-k670t2ahjn2kt559aoiphl0pgbq0n3qv.apps.googleusercontent.com';

root.render(
  <HashRouter>
    <ApiProvider>
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    </ApiProvider>
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
